module.exports = __webpack_public_path__ + "static/media/pr-4.09e5aa3f.jpg";